import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { IBillingDocument, IBillingDocumentFilter } from '../billing-documents.interface';
import { BillingDocumentService } from '../billing-documents.service';
import { InvoiceStatuses } from '../billing-documents.constants';
import moment from 'moment-timezone'
import { IFile, IFileFilter } from '../../../../shared/components/files/file.interface';
import { FileService } from '../../../../shared/components/files/file.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { AlertService } from '../../../../shared/services/alert.service';

declare const $: any;
let self: any;

@Component({
  selector: 'app-billing-documents-bulk-modal',
  templateUrl: './billing-documents-bulk-modal.component.html',
  styleUrls: ['./billing-documents-bulk-modal.component.css']
})
export class BillingDocumentsBulkModalComponent implements OnInit {
  document!: IBillingDocument;
  correctiveInvoice!: IBillingDocument;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  src!: null;
  printType: string = 'extended';
  invoiceStatuses = InvoiceStatuses;
  fileNameDownload: string = '';
  filter: IBillingDocumentFilter = {
    filters: {
      isDeleted: false,
    },
  };
  filterF: IFileFilter = {
    filters: { },
    sort: "-createdAt"
  };
  files!: IFile[];
  
  constructor(
    private _BillingDocumentService: BillingDocumentService,
    private _FileService: FileService,
    public dialogRef: MatDialogRef<any>,
    private _AuthService: AuthService,
    private alertService: AlertService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  lazySearch() {

  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.getFiles();
  }
  

  generateZipFile() {
    const filter = _.cloneDeep(this.filter);
    if(!self.filter.filters.dateStart || !self.filter.filters.dateEnd){
      this.alertService.error("Fechas obligatorias.");
      return;
    }
    this._BillingDocumentService.generateZipFile(filter).subscribe((result: any) => {
        if(result.ok){
            this.alertService.alert(result.msg);
        }
    });

  }

  getFiles(){
    const filterF: any = _.cloneDeep(this.filterF);
    filterF.company = this._AuthService.companyId();
    filterF.filters.contentType = "application/zip";
    this._FileService.getFiles(filterF).subscribe((files: any) => {
        this.files = files;
    });
  }

  downloadExcelFile(){
    const filter: any = _.cloneDeep(this.filter);
    if(!self.filter.filters.dateStart || !self.filter.filters.dateEnd){
      this.alertService.error("Fechas obligatorias.");
      return;
    }
    filter.company = this._AuthService.companyId();
    filter.filters.offset = moment.tz.guess();
    this._BillingDocumentService.downloadExcelFile(filter);
  }

}